import { BorderRadiusTokens, } from '@voltmoney/schema';
export const borderRadiusTypeTokensMap = {
    [BorderRadiusTokens.BR0]: 0,
    [BorderRadiusTokens.BR1]: 4,
    [BorderRadiusTokens.BR2]: 8,
    [BorderRadiusTokens.BR3]: 12,
    [BorderRadiusTokens.BR4]: 16,
    [BorderRadiusTokens.BR5]: 1000,
    [BorderRadiusTokens.BR6]: 24,
};
